// Reine Helfer rund um das konfigurierte Bass-Layout – framework-frei und ohne Store-Zugriff,
// damit sie in Tests ohne Pinia laufen. Das Layout selbst liegt im Settings-Store
// (`useSettingsStore().bassLayout`) und reist in `ConversionSettings` zur Engine.

import type {BassButton, BassLayoutSettings} from '@/generated'

/** Akkordknöpfe tragen einen Kleinbuchstaben; Grundbässe einen Großbuchstaben. */
export function isBassChordButton(button: BassButton): boolean {
  return button.kind === 'chord'
}

/**
 * Alle Griffschrift-Namen des Layouts in Knopfreihenfolge – die Vorlage für die Chips des
 * Bass-Editors in der Notenvorschau. Bewusst aus dem Layout abgeleitet statt hartkodiert: wer
 * sein Instrument umbenennt, soll dieselben Namen auch beim Nachbearbeiten angeboten bekommen.
 */
export function bassSyllables(layout: BassLayoutSettings | null | undefined): string[] {
  const seen = new Set<string>()
  for (const row of layout?.rows ?? []) {
    for (const button of row.buttons ?? []) {
      const name = button.griffschrift?.trim()
      if (name) seen.add(name)
    }
  }
  return [...seen]
}
